import React from 'react';
import { DialogContent, DialogTitle } from '@material-ui/core';
import { useCallbackRef } from '../hooks';
import Dialog from '../dialogs/components/Dialog';
import ExtraCostForm from './ExtraCostForm';
import DialogFormActions from '../dialogs/components/DialogFormActions';
import { IdPropType } from '../../proptypes/basic';

const ExtraCostDialog = ({onClose, customerId, extraCostId}) => {
    const ref = useCallbackRef();
   
    return (
        <Dialog fullWidth maxWidth="md">
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Neue Extrakosten</DialogTitle>

            <DialogContent>
                <ExtraCostForm 
                    customerId={customerId}
                    extraCostId={extraCostId}
                    onDone={onClose}
                    submitRef={ref}
                />
            </DialogContent>

            <DialogFormActions ref={ref} />
        </Dialog>
    );
};

ExtraCostDialog.propTypes = {
    customerId: IdPropType,
    extraCostId: IdPropType,
};

ExtraCostDialog.defaultProps = {
    customerId: null,
    extraCostId: null,
};

export default ExtraCostDialog;
